import { DataTable, Dialog } from "@/components";
import useTaskAssignment from "./useCollectionDetails";
import { Button } from "@/components/ui";
import { SummaryCard } from "./SummaryCard";
import { filter } from "@/assets";
import { Filter } from "./Filter";
import useCollectionDetails from "./useCollectionDetails";

const CollectionDetails = () => {
  const {
    columns,
    openDeleteDialog,
    setOpenDeleteDialog,
    onCancelFilter,
    onFilterBtnClick,
    openFilter,
    filterData,
    setFilterData,
    tableData,
    pageNumber,
    pageSize,
    totalPages,
    totalRecords,
    setPageNumber,
    setPageSize,
    isLoading,
    error,
    isDeleting,
    onFilterApply,
    handleDownloadExcel, 
    isExcelDownloading, 
    totalInvoiceAmount 
  } = useCollectionDetails();

  return (
    <div className="relative">
      {/* Header Buttons */}
      <div className="mb-4 px-5 flex justify-end gap-4">
        <p className="text-[#168F46] font-semibold text-lg">
          Total Amount : ₹ {totalInvoiceAmount}
        </p>
        <Button type="button" variant="ghost" onClick={onFilterBtnClick}>
          <img src={filter} alt="Filter icon" />
          Filter
        </Button>

        <button
          className="cursor-pointer text-primary flex items-center gap-1"
          onClick={handleDownloadExcel}
          disabled={isExcelDownloading}
        >
          {/* Download Icon */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-4 h-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4"
            />
          </svg>
          {isExcelDownloading ? "Downloading..." : "Download Excel"}
        </button>
      </div>
      


      {/* Table Section */}
      {isLoading && <div>Loading...</div>}
      {error && <div>Error: {error.message}</div>}
      {!isLoading && !error && (
        <DataTable
          columns={columns}
          data={tableData}
          serviceSidePagination={false}
          pageNumber={pageNumber}
          pageSize={pageSize}
          totalPages={totalPages}
          totalRecords={totalRecords}
          setPageNumber={setPageNumber}
          setPageSize={setPageSize}
        />
      )}

      {/* Delete Confirmation Dialog */}
      {openDeleteDialog && (
        <Dialog
          open={openDeleteDialog}
          setOpen={setOpenDeleteDialog}
          title="Delete Task Assignment"
          // onSave={onConfirmDelete}
          saveText="Delete"
          saveBtnClassName="bg-red-600 hover:bg-red-500"
          isLoading={isDeleting}
        >
          <div className="flex flex-col gap-4">
            <p>Are you sure you want to delete this task assignment?</p>
          </div>
        </Dialog>
      )}

      {/* Filter Drawer */}
      {openFilter && (
  <Filter
    onCancel={onCancelFilter}
    filterData={filterData}
    setFilterData={setFilterData}
    onApply={onFilterApply}
  />
)}

    </div>
  );
};

export default CollectionDetails;
